<template>
  <div>
    <v-row dense align="center">
      <v-col cols="12" sm="9" class="text-truncate">
        <px-situacao-cotacao-icon :situacao="cotacao.situacao"/>
        {{ cotacao.identificador }}
      </v-col>
      <v-col cols="12" sm="3" class="text-right">
        <px-cancelamento-cotacao-button
          v-if="hasModuleGerencia"
          :disabled="!isAberta"
          :cotacao="cotacao"
          @cancelada="onClickCancel"/>
          <v-tooltip top v-if="hasModuleGerencia">
            <template v-slot:activator="{ on }">
              <v-btn icon
                     v-on="{ on }"
                     :disabled="!isAberta"
                     @click="onClickEdit">
                <v-icon>
                    mdi-pencil
                </v-icon>
              </v-btn>
            </template>
              <span>Editar cotação</span>
          </v-tooltip>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-icon>mdi-domain</v-icon>
        {{ cotacao.comprador.pessoa.nome }} ({{ cotacao.comprador.pessoa.cnpj | cnpj }})
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" class="caption">
        <v-icon>mdi-map-marker</v-icon>
        {{ cotacao.comprador.endereco | endereco }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoCotacao } from 'px-business-components';
import CancelamentoCotacaoButton from '../movimentacao/CancelamentoCotacaoButton.vue';

export default {
  props: {
    cotacao: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    isAberta() {
      return SituacaoCotacao.keys.ABERTA.key === this.cotacao.situacao;
    },
  },
  methods: {
    onClickCancel() {
      this.$emit('movimentada', this.cotacao);
    },
    onUpdate() {
      this.$emit('movimentada', this.cotacao);
    },
    onClickEdit() {
      this.$router.push({ name: 'main.cotacoes.edicao-parcial' });
    },
  },
  components: {
    pxCancelamentoCotacaoButton: CancelamentoCotacaoButton,
  },
};
</script>
